import ContentSingle from "../components/ContentSingle/ContentSingle"
import Footer from "../components/Footer/Footer"

function Movies(){

    return(
        <>
        <ContentSingle title="Movies" type="movie" form="single"/>
        </>
    )
}

export default Movies